export const competenceDomainKeys = {
  all: ['competenceDomains'] as const,
  classList: (schoolClassId?: number) => [...competenceDomainKeys.all, 'list', schoolClassId] as const,
  templates: (schoolSubjectTemplateId?: number) =>
    [...competenceDomainKeys.all, 'templates', schoolSubjectTemplateId] as const,
  details: () => [...competenceDomainKeys.all, 'detail'] as const,
  detail: (domainId: number) => [...competenceDomainKeys.details(), domainId] as const,
};
